import { ThemeProperties } from '../../../core';

export interface InputTimeTheme {
	iconPaddingLeft: string;
	iconColor: string;
	iconSize: string;
}
export const theme = new ThemeProperties('inputTime');
